var BigInteger = require('./bigi')

//addons
require('./convert')

module.exports = BigInteger


//////////////////
// WEBPACK FOOTER
// ./node_modules/bigi/lib/index.js
// module id = 13
// module chunks = 0